<script setup>
// BonBoZ: thẻ một lượt kết bạn Zalo (message activity, Rails cập nhật tại chỗ).
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import ZaloAPI from 'dashboard/api/bonboz/zalo';
import { loiApi } from 'dashboard/api/pageConfigs';
import { useMessageContext } from '../provider.js';
import {
  khoaPill,
  mauPill,
  mauBuoc,
  khoaNhanLoiNhan,
  chuBuoc,
  gioBuoc,
} from 'dashboard/helper/zaloKetBan';

const { contentAttributes, inboxId } = useMessageContext();
const { t } = useI18n();

const the = computed(() => contentAttributes.value?.bonbozZaloKetBan || {});
const khach = computed(() => the.value.khach || {});
const nhanLoiNhan = computed(() =>
  khoaNhanLoiNhan(the.value.huong, the.value.loiNhan)
);
const coNut = computed(
  () => the.value.trangThai === 'cho' && the.value.huong === 'den'
);

// Không đổi trạng thái tại chỗ: Rails update message rồi broadcast.
const dangGui = ref(false);
const traLoi = async dongY => {
  dangGui.value = true;
  try {
    const goi = dongY ? ZaloAPI.dongY : ZaloAPI.tuChoi;
    await goi.call(ZaloAPI, inboxId.value, khach.value.uid);
  } catch (e) {
    useAlert(loiApi(e));
  } finally {
    dangGui.value = false;
  }
};
</script>

<template>
  <div
    class="w-[min(370px,calc(100cqw-5rem))] mx-auto rounded-xl border border-n-weak bg-n-solid-1 text-n-slate-12 overflow-hidden"
    data-bubble-name="zalo-ket-ban"
  >
    <div
      class="flex items-center gap-2 px-3 py-2 border-b border-n-weak text-sm"
    >
      <i class="i-woot-zalo size-4 shrink-0" aria-hidden="true" />
      <span class="font-medium flex-1 min-w-0 truncate">
        {{ t('BONBOZ.KET_BAN.TIEU_DE') }}
      </span>
      <span
        class="px-2 py-0.5 rounded-full text-xs font-medium shrink-0"
        :class="mauPill(the.trangThai)"
      >
        {{ t(khoaPill(the.trangThai, the.huong)) }}
      </span>
    </div>

    <div class="flex flex-col gap-3 p-3">
      <div class="flex items-center gap-3 min-w-0">
        <Avatar
          :src="khach.avatar || ''"
          :name="khach.ten || '?'"
          :size="40"
          rounded-full
        />
        <div class="min-w-0">
          <div class="text-sm font-medium truncate">{{ khach.ten || '–' }}</div>
          <div v-if="khach.sdt" class="text-xs text-n-slate-11">
            {{ khach.sdt }}
          </div>
        </div>
      </div>

      <div
        v-if="nhanLoiNhan"
        class="px-3 py-2 rounded-lg bg-n-alpha-1 border-l-2 border-n-slate-6"
      >
        <div class="text-xs text-n-slate-11 mb-0.5">{{ t(nhanLoiNhan) }}</div>
        <div class="text-sm whitespace-pre-line break-words">
          {{ the.loiNhan }}
        </div>
      </div>

      <ol
        v-if="the.buoc?.length"
        class="flex flex-col gap-1.5 m-0 p-0 list-none"
      >
        <li
          v-for="(b, i) in the.buoc"
          :key="i"
          class="flex items-center gap-2 text-xs"
        >
          <span class="size-2 rounded-full shrink-0" :class="mauBuoc(b.loai)" />
          <span class="flex-1 min-w-0 truncate text-n-slate-12">
            {{
              t(
                chuBuoc(b, the.huong, khach.ten).key,
                chuBuoc(b, the.huong, khach.ten).params
              )
            }}
          </span>
          <span class="text-n-slate-10 shrink-0">{{ gioBuoc(b.luc) }}</span>
        </li>
      </ol>

      <div v-if="coNut" class="flex gap-2">
        <NextButton
          class="flex-1 justify-center"
          :label="t('BONBOZ.KET_BAN.TU_CHOI')"
          slate
          faded
          sm
          :disabled="dangGui"
          @click="traLoi(false)"
        />
        <NextButton
          class="flex-1 justify-center"
          :label="t('BONBOZ.KET_BAN.DONG_Y')"
          sm
          :disabled="dangGui"
          @click="traLoi(true)"
        />
      </div>
    </div>
  </div>
</template>
